import { memo } from 'react'

import {
  Box,
  AppShell as MantineShell,
  useMantineColorScheme,
} from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { HeadContent, Outlet } from '@tanstack/react-router'

import { Navbar } from '@/components/Navbar/Navbar.tsx'
import { RequireAccess } from '@/components/RequireAccess'
import { RequireLogin } from '@/components/RequireLogin'

import classes from './AppShell.module.css'

// TODO: page animations: https://github.com/TanStack/router/discussions/823
export const AppShell = memo(function AppShell() {
  return (
    <RequireLogin>
      <RequireAccess>
        <AppShellNoLoginRequired />
      </RequireAccess>
    </RequireLogin>
  )
})

export const AppShellNoLoginRequired = memo(function AppShellNoLoginRequired() {
  const [mobile_open, { close }] = useDisclosure()
  const { colorScheme } = useMantineColorScheme()
  const isDark = colorScheme == 'dark'

  return (
    <>
      <HeadContent />

      <MantineShell
        withBorder={false}
        padding={16}
        classNames={{ root: classes.root }}
        navbar={{
          width: 82,
          breakpoint: 'sm',
          collapsed: { mobile: !mobile_open, desktop: false },
        }}
      >
        <MantineShell.Navbar className={classes.navbar} onClick={close}>
          <Navbar />
        </MantineShell.Navbar>
        <MantineShell.Main
          bg={isDark ? 'dark.8' : 'gray.1'}
          className={classes.main}
        >
          <Box
            className={classes.content_container}
            mih="calc(100vh - 200px)"
            px={{
              base: 'var(--app-body-margin)',
              sm: 'calc(var(--mantine-spacing-md) + 0.5rem)',
              md: 'var(--app-body-margin)',
            }}
          >
            <Outlet />
          </Box>
        </MantineShell.Main>
      </MantineShell>
    </>
  )
})
